module.exports = __webpack_public_path__ + "img/abhijata.49fc579b.png";